import { ServiceLayoutColumn } from './service-layout-column';
import { ListData } from './list-data';
import { ObjectProperties } from './object-properties';
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';
import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';

let metaData = {
    IsSearchReturnedResult: DataType.BOOL,
    Loading: DataType.BOOL,
    LinkedRecords: DataType.OBJECT
};

KnownPropertyTypes.setFor(metaData);

export abstract class AbstractServiceRecord implements IGenericAccessor {
    public IsCollectionDiff?: boolean;
    public ChatData: Array<any>;
    public DefaultLayout: {
        DefaultLayout: Array<ServiceLayoutColumn>,
        DefaultLayoutType: number
    };
    public IsSearchReturnedResult?: boolean;
    public ListData: ListData;
    public Loading?: boolean;
    public ObjectLinks: any; // unused
    public ObjectProperties: Array<{ FieldName: string, FieldValue: any }>; // Array from service
    public ObjectPropertiesCollection: ObjectProperties;
    public ObjectTags: any; // unused
    public SocialMediaLinks: any; // unused
    public LinkedRecords: Array<any> = [];

    private getMyMetaData(): { [id: string]: number } {
          let objectKeys = Object.keys(this);
          let ret = {};
          for (let prop of objectKeys) {
              if(metaData[prop]) ret[prop] = metaData[prop];
          }
          return (ret);
    }

    public getMetaData(): { [id: string]: number } {
        let ret = this.getMyMetaData();
        let listMetaData = this.ListData.getMetaData();
        let objectPropertiesMetaData = this.ObjectPropertiesCollection.getMetaData();

        // merge
        for (let p in listMetaData) {
            ret[p] = listMetaData[p];
        }

        for (let p in objectPropertiesMetaData) {
            if (!ret[p]) ret[p] = objectPropertiesMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getMyMetaData()[field]) {
            return this[field];
        } else if (this.ListData.getMetaData()[field]) {
            return this.ListData.getRawValue(field);
        } else return this.ObjectPropertiesCollection.getRawValue(field);
    }

    public instantiateChildren() {
        this.ListData = Object.assign(new ListData(), this.ListData);
        this.ObjectPropertiesCollection = new ObjectProperties(this.ObjectProperties);
    }
}
